import { render, staticRenderFns } from "./forgot-password-page.vue?vue&type=template&id=7dbb4903&scoped=true&"
import script from "./forgot-password-page.vue?vue&type=script&lang=js&"
export * from "./forgot-password-page.vue?vue&type=script&lang=js&"
import style0 from "./forgot-password-page.vue?vue&type=style&index=0&id=7dbb4903&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbb4903",
  null
  
)

export default component.exports